import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router-dom'
import { Headset } from 'lucide-react'
import { PageScroll } from 'app/components/layout/PageScroll'
import { PageHeaderComponent } from 'app/components/page-header/PageHeaderComponent'
import { Toggle } from 'app/components/ui/toggle'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'app/components/ui/tooltip'
import { Button } from 'app/components/ui/button'
import type { TabType } from 'app/components/ui/nav-tabs'

export type SettingsAIAgentLocationComponentProps = {
  locationName: string
  tabs: TabType[]
  isAgentLive: boolean
  testPhoneNumber: string | undefined
  onToggleAgentLive: (value: boolean) => Promise<boolean>
}

export const SettingsAIAgentLocationComponent = observer(function SettingsAIAgentLocationComponent({
  locationName,
  tabs,
  isAgentLive,
  testPhoneNumber,
  onToggleAgentLive,
}: SettingsAIAgentLocationComponentProps) {
  return (
    <PageScroll
      contentClassName="mt-2 flex flex-col"
      header={
        <PageHeaderComponent
          title={locationName}
          tabs={tabs}
          primaryButtonSlot={
            <Toggle
              defaultValue={isAgentLive}
              label="AI Agent Live"
              handleToggle={onToggleAgentLive}
              controlled
              labelClassName="text-strong text-body-sm"
            />
          }
          secondaryButtonSlot={
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button variant="white" size="sm" className="my-1 mr-1 cursor-help" disabled>
                    <Headset className="h-4 w-4" />
                    <span>{testPhoneNumber}</span>
                  </Button>
                </TooltipTrigger>
                <TooltipContent side="bottom">Agent Test Number</TooltipContent>
              </Tooltip>
            </TooltipProvider>
          }
        />
      }
    >
      <Outlet />
    </PageScroll>
  )
})
